import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { FETCH_ALERT_BANNER_NAME } from './alertBannerBreadcrumb.query';

export const AlertBannerBreadcrumb = () => {
  const { id } = useParams();
  const { data } = useQuery(FETCH_ALERT_BANNER_NAME, {
    variables: { alertBannerId: id ?? '' },
    skip: !id,
  });

  return data?.fetchAlertBanner?.alertBanner?.name ?? '';
};
